module.exports = __webpack_public_path__ + "static/img/icn_forgot_pw@3x.ca5db35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icn_forgot_pw@3x.png
// module id = 0Ifu
// module chunks = 10